import Button from 'components/button';
import { FavouritesType } from 'lib/dictionary';
import { EFavoritesType } from 'lib/types';
import styles from './styles.module.scss';
import { Input } from 'components/input';
import { useState } from 'react';
import useChangeFavoriteList from 'api/hooks/use-favorite-list-change';

interface IChangeNameFavoriteListForm {
  id: number;
  type: EFavoritesType;
  baseName: string;
  onClose: () => void;
  refetchFavoriteList: () => void;
}

const ChangeNameFavoriteListForm = ({
  type,
  onClose,
  refetchFavoriteList,
  baseName,
  id,
}: IChangeNameFavoriteListForm) => {
  const [name, setName] = useState(baseName);

  const { trigger, isMutating, error } = useChangeFavoriteList(id);

  const handleChangeName = async () => {
    if (id && name) {
      await trigger({ title: name });
      onClose();
      refetchFavoriteList();
    }
  };

  const handleChange = (value: string) => {
    setName(value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>{`${FavouritesType.label(type)} список`}</div>

      <div className={styles.input}>
        <Input
          label='Название списка'
          defaultValue={baseName}
          value={name}
          onChange={handleChange}
        />
      </div>

      <div className={styles.flexButton}>
        <Button variant='gray' onClick={onClose} label='Отменить' />
        <Button
          loading={isMutating}
          onClick={() => {
            handleChangeName();
          }}
          label='Изменить'
        />
      </div>
    </div>
  );
};

export default ChangeNameFavoriteListForm;
